import Icon from '../Icon';
import {useOnline} from '../../hooks/useOnline';

// A quiet band at the top while there is no signal. Phase 1: words always save when the request
// gets through, photos wait in the upload queue. Phase 2 makes saving itself offline-safe.
export default function OfflineBanner() {
    const online = useOnline();
    if (online) return null;
    return (
        <div role="status" className="settle-in -mx-4 mb-3 flex items-center gap-2 bg-kind-plain-bg px-4 py-2 text-xs font-semibold text-kind-plain-fg">
            <Icon name="weather" size={16} />
            No signal. Photos will follow when you&rsquo;re back online.
        </div>
    );
}
